import factsRaw from '../../wombat_facts?raw';

export const WOMBAT_FACTS: string[] = factsRaw
  .split(/\r?\n\r?\n/g)
  .map((fact) => fact.trim())
  .filter((fact) => fact.length > 0);

export function shuffleFacts(source: string[], rng: () => number = Math.random): string[] {
  const facts = [...source];
  for (let i = facts.length - 1; i > 0; i -= 1) {
    const j = Math.floor(rng() * (i + 1));
    [facts[i], facts[j]] = [facts[j], facts[i]];
  }
  return facts;
}
